import { useQuery } from '@tanstack/react-query';
import type { inferInput, inferOutput } from '@trpc/tanstack-react-query';
import { useTRPC } from './trpc.js';

type TRPC = ReturnType<typeof useTRPC>;

export type WatchScope = inferInput<TRPC['dashboard']['creativesToWatch']>;
export type WatchData = inferOutput<TRPC['dashboard']['creativesToWatch']>;
export type WatchedCreative = WatchData['creatives'][number];
export type WatchStatus = WatchedCreative['status'];

export function useCreativesToWatch(scope: WatchScope, enabled: boolean) {
  const trpc = useTRPC();
  return useQuery({ ...trpc.dashboard.creativesToWatch.queryOptions(scope), enabled });
}
